// src/lib/locations.js
// ───────────────────────────────────────────────────────────────────────────
// 📍 Ubicaciones (PLAN-INVENTARIO-RETALES §4b)
// Listas predefinidas (warehouses/racks/zones — config en datos) + paletas
// móviles license-plate. El ítem que vive EN una paleta NO duplica su zona:
// se resuelve AL LEER desde pallet.currentLocation (no se desincroniza).
// ───────────────────────────────────────────────────────────────────────────
import { collection, getDocs } from 'firebase/firestore';

/** Carga las listas de ubicación + paletas (para pickers y resolución de labels). */
export async function loadLocationConfig(db) {
    const grab = async (name) => {
        const snap = await getDocs(collection(db, name));
        return snap.docs.map((d) => ({ id: d.id, ...d.data() }))
            .sort((a, b) => (a.order ?? 999) - (b.order ?? 999) || String(a.name || a.code || a.id).localeCompare(String(b.name || b.code || b.id)));
    };
    const [warehouses, racks, zones, pallets] = await Promise.all([
        grab('warehouses'), grab('racks'), grab('zones'), grab('pallets'),
    ]);
    return { warehouses, racks, zones, pallets };
}

const byId = (arr, id) => (arr || []).find((x) => x.id === id) || null;

/** Label de una ubicación FIJA (rack/zona): "Almacén principal · Rack B-4". PURO. */
export function staticLocationLabel(loc, cfg) {
    if (!loc) return '';
    const wh = byId(cfg?.warehouses, loc.warehouseId);
    const place = loc.type === 'rack' ? byId(cfg?.racks, loc.rackId) : byId(cfg?.zones, loc.zoneId);
    const parts = [wh?.name, place?.name].filter(Boolean);
    return parts.join(' · ') || loc.label || '';
}

/**
 * Label COMPLETO de la ubicación de un ítem. Si está en paleta, resuelve la
 * zona ACTUAL de la paleta al leer: "PAL-007 → Zona C". PURO.
 */
export function locationLabel(loc, cfg) {
    if (!loc) return '';
    if (loc.type === 'pallet') {
        const pallet = byId(cfg?.pallets, loc.palletId);
        const code = pallet?.code || loc.palletId || '';
        const zone = pallet ? staticLocationLabel(pallet.currentLocation, cfg) : '';
        return zone ? `${code} → ${zone}` : code;
    }
    return staticLocationLabel(loc, cfg) || loc.label || '';
}
